<script setup>
import { getI18n } from '@/plugins/i18n.js'
import { ref, onMounted } from 'vue'

import router from '@/router.js'

import { useNotify } from '@/composables/notify'
import { refreshAllStoresAsync } from '@/composables/store'

import { usePortalStore } from '@/stores/portal.store'
import { useWebSiteStore } from '@/stores/web-site.store'
import { webSiteApi } from '@/apis/web-site.api'
import FadeTransition from '@/components/shared/FadeTransition.vue'

const { notifyInfo } = useNotify()
const webSiteStore = useWebSiteStore()
const bar = ref(null)
const i18n = getI18n()

const requestFilter = (url) => {
  if (url === (webSiteApi.getAbsoluteUrl() + webSiteApi.notificationsUnreadCountUrl)) {
    return false
  }
  return true
}

let refreshing = false

const resetAndRefreshAsync = async () => {
  refreshing = true
  const portalStore = usePortalStore()
  portalStore.localizationsReset()
  await refreshAllStoresAsync()
}

const onSoftwareUpdated = (event) => {
  if (refreshing) return

  const doReload = async () => {
    await resetAndRefreshAsync()
    if (event.detail && typeof event.detail === 'function') {
      event.detail()
    } else {
      window.location.reload()
    }
  }

  notifyInfo(i18n.t('common.softwareUpdated'), {
    timeout: 0,
    actions: [
      {
        label: i18n.t('common.reload'),
        handler: doReload,
      },
    ],
  })
}

document.addEventListener('keydown', (e) => webSiteStore.dispatchKeydown(e), { capture: true })
document.addEventListener('softwareUpdated', onSoftwareUpdated, { once: true })
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.addEventListener('controllerchange', async () => {
    if (refreshing) return
    await resetAndRefreshAsync()
    window.location.reload()
  })
}
const isLoaded = ref(false)

onMounted(async() => {
  const portalStore = usePortalStore()
  await portalStore.fetchVersionAsync()
  isLoaded.value = true
  router.beforeEach((to, from, next) => {
    if (bar.value) {
      bar.value.start()
    }
    next()
  })
  router.afterEach(() => {
    if (bar.value) {
      bar.value.stop()
    }
  })
  document.documentElement.style.fontSize = portalStore.fontSize + 'rem'
})

</script>
<template>
  <div v-if="isLoaded">
    <q-ajax-bar
      ref="bar"
      :hijack-filter="requestFilter"
    />
    <Suspense>
      <router-view v-slot="{ Component }">
        <fade-transition appear>
          <component :is="Component" />
        </fade-transition>
      </router-view>
    </Suspense>
  </div>
</template>
